import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_URL } from '../models/api-url.token';
import { IMyOskLectureGroupVm } from '../my-osk-lecture-group-vm.model';
import { IMyOskLectureGroupIm } from '../my-osk-lecture-group-im.model';
import { IMyOskLectureGroupUm } from '../my-osk-lecture-group-um.model';
@Injectable({ providedIn: 'root' })
export class MyOskLectureGroupService {
  private readonly baseUrl: string;
  constructor(private http: HttpClient, @Inject(API_URL) private apiUrl: string) {
    this.baseUrl = `${this.apiUrl}/MyOskLectureGroup`;
  }
  get(guid: string): Observable<IMyOskLectureGroupVm> {
    const headers = this.createHeaders();
    let params = new HttpParams();
    if (guid !== undefined && guid !== null) {
      params = params.set('guid', guid.toString());
    }
    return this.http.get<IMyOskLectureGroupVm>(this.baseUrl, { headers, params });
  }
  post(myOskLectureGroupIm: IMyOskLectureGroupIm): Observable<IMyOskLectureGroupVm> {
    const headers = this.createHeaders();
    return this.http.post<IMyOskLectureGroupVm>(this.baseUrl, myOskLectureGroupIm, { headers });
  }
  put(myOskLectureGroupUm: IMyOskLectureGroupUm): Observable<IMyOskLectureGroupVm> {
    const headers = this.createHeaders();
    return this.http.put<IMyOskLectureGroupVm>(this.baseUrl, myOskLectureGroupUm, { headers });
  }
  delete(guid: string): Observable<boolean> {
    const headers = this.createHeaders();
    let params = new HttpParams();
    if (guid !== undefined && guid !== null) {
      params = params.set('guid', guid.toString());
    }
    return this.http.delete<boolean>(this.baseUrl, { headers, params });
  }
  private createHeaders(): HttpHeaders {
    let headers = new HttpHeaders();
    const token = localStorage.getItem('authToken');
    if (token) headers = headers.set('Authorization', `Bearer ${token}`);
    return headers;
  }
}
